// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .p-ripple {
    opacity: 0;
} */

.p-tabview .p-tabview-nav li {
  margin-left: 5px !important;
}

.p-tabview .p-tabview-nav {
  position: absolute;
  z-index: 1;
}

.p-tabview .p-tabview-nav li {
  margin-left: -15px !important;
  padding: 0px 15px 0px 15px;
  position: relative;
  /* bottom: 2px; */
  top: 6px;
  margin-right: -4px !important;

  &:first-child {
    bottom: 0.04rem;
  }
}

.p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link {
  font-size: 12px !important;
  background-color: #ffe600;
  font-weight: 400;
  color: #212529 !important;
  border: none !important;
  /* border: 1px solid #ffe600 !important; */
}
/* p-table table tbody tr td:nth-child(4) select,
p-table table tbody tr td:nth-child(2) select {
  display: none;
} */

.btn-like-link {
  background-color: #6495ed;
}
.rightbtns {
  position: relative;
  left: 10px;
  .gobackbtn {
    padding: 10px 24px;
    border-top-right-radius: 3px !important;
    border-top-left-radius: 3px !important;
  }
  .savebtn {
    padding: 10px 30px;
    border-top-right-radius: 3px !important;
    border-top-left-radius: 3px !important;
  }
}
.initialgrid {
  border-bottom: none !important;
  overflow: hidden;
  .p-datatable-thead th:nth-child(5) {
    width: 37.5%;
  }
  .p-datatable-thead th:nth-child(6) {
    width: 28.5%;
  }
}

.bsgrid {
  .p-datatable-thead th:nth-child(6) {
    width: 36% !important;
  }
}

.firstgrid {
  border-bottom: none !important;
}

.secondgrid {
  .firsttb {
    .p-datatable-thead th:nth-child(5) {
      padding-right: 62px !important;
    }
  }
  .p-datatable-thead th:nth-child(5) {
    padding-right: 42px !important;
  }
}
.p-datatable .p-datatable-tbody > tr > td:nth-child(6) {
  padding-right: 10px !important;
}
.secondgrid {
  border-left: 1px solid black !important;
  border-right: 1px solid black !important;
  border-bottom: 1px solid black !important;
  border-top: none !important;
  .secondtb {
    .fa-times {
      color: #ff0000;
    }
select {
  margin-top: 1px;
 }
  }
  .p-datatable .p-datatable-thead > tr > th:nth-child(1),
  .p-datatable .p-datatable-thead > tr > th:nth-child(2),
  .p-datatable .p-datatable-thead > tr > th:nth-child(3),
  .p-datatable .p-datatable-thead > tr > th:nth-child(4),
  .p-datatable .p-datatable-thead > tr > th:nth-child(6) {
    visibility: hidden;
  }
  .p-datatable-tbody > tr:nth-child(odd) {
    background: #fff !important;
  }
  .p-datatable-tbody > tr:nth-child(even) {
    background: #f5f5f5 !important;
  }
  .p-datatable-thead th {
    background: #fff !important;
  }
}
.tablegrid {
  margin-left: 15px;
}
.tablegridplsection {
  .maximize-button {
    .secondgrid {
      background: #fff;
    }
  }
}
.minimized {
  .maximize-button {
    right: -12px !important;
    position: absolute;
    top: 15px;
    z-index: 1;
    background: none;
    border: none;
    font-size: 20px;
  }
}
.maximized {
  .maximize-button {
    z-index: 10000;
    position: absolute;
    right: 1px !important;
    top: 14px;
    background: none;
    border: none;
    font-size: 20px;
  }
  .PadLNull {
    padding-right: 0;
  }
  background: #fff;
}
.tablegridbssection {
  .maximize-button {
    .secondgrid {
      background: #fff;
    }
  }
  .full {
    overflow: hidden;
  }
}
.maximized {
  width: 100%;
  height: 100%;
  position: relative;
  top: 0;
  left: 0;
  z-index: 1;
  overflow: auto;
  margin-left: 1px !important;
  .PadLNull {
    overflow: visible;
    width: 100%;
  }
  .secondgrid {
    background: #fff;
  }
  .rightbtnsbtm {
    margin-bottom: 30px !important;
  }
}

.minimized {
  height: 50%;
  position: relative;
  z-index: 1;
}
.maximized {
  .modify {
    display: none;
  }
  .modifybtn {
    display: none;
  }
}
.minimized {
  .maxintable {
    margin-right: 50%;
    margin-top: 80px;
  }
}
.maximized {
  .maxintable {
    right: 30px !important;
    top: 97px !important;
  }
}

.minimized {
  .maxintablebs {
    margin-right: 33.5% !important;
    margin-top: 80px !important;
  }
}

.maximized {
  .maxintablebs {
    right: 30px !important;
    top: 97px !important;
  }
}
.addstdbtn {
  border-radius: 10px !important;
  padding: 5px;
  width: 54%;
  font-size: 16px !important;
  color: black;
  background-color: #ccc;

  &:focus {
    background-color: #ffe600 !important;
    box-shadow: none;
  }
}

#inputIdPl {
  border-color: red !important;
}

#inputIdBs {
  border-color: red !important;
}
.cancelbtn {
  background-color: #dedede !important;
  border: 1px solid #ccc!important;
}

.yesbtn{
  background-color: #ffe600 !important;
  border: 1px solid #ffe600 !important;
}

.popUpCancel {
  width: 400px !important;
}

.initialheight {
  border: 1px black solid;
  border-bottom: 1px solid black !important;
}

.afterdataloadheight {
  border: 1px black solid;
  height: auto;
}

.validlayoutname{
  color: black;
  background-color: white;
  width: 340px;
  border-color: #ced4da !important;
}

.invalidlayoutname{
  color: black;
  background-color: white;
  width: 340px;
  border-color: red !important;
}

.layoutpreview{
  height: 300px;
  font-size: 30px;
  text-align: center !important;
  color: black;
  position: relative;
  bottom: 30px;
}

.dropdownlabelfont{
  color: black;
  font-size: 16px;
  font-weight: 100;
}


::ng-deep .p-dialog .p-autocomplete {
  display: block !important;
  color: #000 !important;
  /* width: 100% !important; */
  background: white !important;
}
/* ::ng-deep .p-dialog .p-autocomplete-panel {
  display: block !important;
  /* width: 100% !important;
  color: #000;
  background-color: white !important;
} */

::ng-deep .p-dialog .p-autocomplete-input {
  display: block !important;
  /* width: 100% !important; */
  background-color: white !important;
}

::ng-deep p-autocomplete .p-autocomplete-multiple-container {
  border-color: #ced4da !important;
  background: white !important;
  overflow-y: auto;
}
.scroll{
  overflow-y: auto;
  max-height: 600px;
  background-color: #000 !important;
}

::ng-deep .p-autocomplete-panel .p-autocomplete-items .p-autocomplete-item.p-highlight {
  color: #dedede;
  background: transparent;
  transition: background-color .2s, border-color .2s, box-shadow .2s;
}

::ng-deep .p-dialog .p-dialog-header .p-dialog-title{
  font-size: 20px !important;
}

/* Reference layout at the standard 1024px application viewport. */
:host {
  display: block;
}

.tablegrid {
  margin-left: 20px;
  margin-right: 20px;
}

:host ::ng-deep .p-tabview .p-tabview-nav {
  left: 0;
  top: 0;
  height: 33px;
  display: flex !important;
  flex-direction: row !important;
  flex-wrap: nowrap !important;
  align-items: stretch;
}

:host ::ng-deep .p-tabview .p-tabview-nav li {
  width: 106px;
  height: 33px;
  display: block !important;
  float: none !important;
  flex: 0 0 106px;
  margin: 6px 1px 0 0 !important;
  padding: 0 !important;
  top: 0;
}

:host ::ng-deep .p-tabview .p-tabview-nav li .p-tabview-nav-link {
  width: 100%;
  height: 33px;
  padding: 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px !important;
}

.rightbtns {
  left: 0;
  width: 100%;
  height: 32px;
  display: flex;
  justify-content: flex-end;
  align-items: stretch;
  gap: 8px;
  float: none !important;
}

.rightbtns .savebtn {
  height: 32px;
  margin: 0 !important;
  padding: 0 !important;
  line-height: 30px;
  border-radius: 0 !important;
  flex: 0 0 auto;
}

.rightbtns > .savebtn:nth-of-type(1) {
  width: 134px;
}

.rightbtns > .savebtn:nth-of-type(2) {
  width: 91px;
}

.rightbtns > .savebtn:nth-of-type(3) {
  width: 84px;
}

.rightbtns > .savebtn:nth-of-type(4) {
  width: 97px;
}

.rightbtns > span {
  height: 32px;
  flex: 0 0 89px;
}

.rightbtns > span .savebtn {
  width: 89px;
}

.tablegridplsection,
.tablegridbssection {
  width: 100%;
}

.initialheight {
  height: 296px;
  overflow: hidden;
  border: 1px solid #191919 !important;
}

:host ::ng-deep .firstgrid > .PadLNull {
  position: relative;
}

:host ::ng-deep .firstgrid .maxintable {
  position: absolute;
  left: 100%;
  top: 4px;
  right: auto !important;
  margin: 0 !important;
  padding: 0 2px !important;
}

:host ::ng-deep .initialgrid .p-datatable {
  width: 100%;
}

:host ::ng-deep .initialgrid .p-datatable .p-datatable-thead > tr > th {
  height: 49px;
  padding: 7px 10px !important;
  background: #dedede !important;
  color: #333 !important;
  border: 1px solid #ccc !important;
  font-size: 12px !important;
  font-weight: 400 !important;
  line-height: 15px;
}

.layoutpreview {
  height: 246px;
  padding-top: 82px !important;
  bottom: auto;
  font-size: 26px;
  line-height: 31px;
  vertical-align: top;
}
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
